module.exports = __webpack_public_path__ + "img/3-01-19-human-safety.121d3797.svg";